import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const zeroUTasks = api(({ regimeId, group, filters = [], search }) =>
    query(
        gql`
            query ZeroUTasks($regimeId: String!, $group: String, $filters: [JSONObject], $search: String) {
                regimeAssetTaskSummary(regimeId: $regimeId, group: $group, filters: $filters, search: $search) {
                    id
                    summarise(
                        by: [
                            "task.title"
                            "frequency.period"
                            "frequency.interval"
                            "minutes"
                            "skill"
                            "schedule.title"
                        ]
                    ) {
                        total
                        summary(take: 10000) {
                            value
                            count
                            tasks {
                                id
                                items(take: 1) {
                                    id
                                    scheduleId
                                    skill
                                    minutes
                                    frequency {
                                        interval
                                        period
                                        label
                                    }
                                    schedule {
                                        id
                                        version
                                        _id
                                        title
                                        code
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
        { regimeId, group, filters: [{ "frequency.label": "0U" }, ...filters], search },
        { returns: "regimeAssetTaskSummary" }
    )
)
